import { Container, Grid, MenuItem } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '@/routes/paths';
import { createOrdersService, findUsersByBranch, getProductsResumeService } from '@/services';
import { Roles, searchFilter, translates } from '@/utils';
import { errorOrders } from '@/utils/errors';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
  Input,
} from '@nextui-org/react';
import './styles.css';
import { Button as ButtonPorky } from '@PorkyCol/button';
import { useQuery } from '@tanstack/react-query';
import { object } from 'yup';
import { useCompanyCategory } from '@/hooks/useCompanyCategory';
import { Iconic } from '@commons/iconic';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  orderSchema,
  orderSchemaOptional,
  orderSimpleSchemaOptional,
} from '@modules/orders/form/order/validation';
import { Order } from '@modules/orders/types';
import { useAuthContext } from '@hooks/useAuthContext';
import { defaultValuesProductForm } from '@modules/orders/form/order/initial-values';
import FormProvider, { TWTextField, RHFSelect } from '@commons/hook-form';
import { useItemList } from '@modules/orders/hooks/useItemsList';
import { OrderSimpleButtons } from '@modules/orders/form/order-button';
import { OrderFacturePreview } from '@modules/orders/form/order-facture-preview';
import { useFetch } from '../hooks/useFetch';
import { SearchIcon } from './Icons/SearchIcon';

export const CreateSimpleOrder = () => {
  const { isFoodCompany } = useCompanyCategory();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [idDescriptionProduct, setIdDescriptionProduct] = useState('');
  const [description, setDescription] = useState('');
  const [searchTerm, setSearchTerm] = useState<string >("");


 /*   console.log("🚀 ~ CreateSimpleOrder ~ data", data)
   */
  const [selectedProducts, setSelectedProducts] = useState<
    {
      name: string;
      price: number;
      quantity: number;
      id: string;
      description?: string;
    }[]
  >([]);

  const onCreateOrdersService = async (values: any) => {
    try {
      const resolve = await onSubmitCreateOrder(values);
      if (resolve.error) {
        const errorMessage =
          errorOrders[resolve?.error ?? resolve?.error.message] ?? 'Problemas Añadiendo Productos';
        enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });
      } else {
        navigate(PATH_DASHBOARD.orders.view(resolve?.id));
      }
    } catch (error) {
      const errorMessage = errorOrders[error?.error.message] ?? 'Problemas Añadiendo Productos';
      enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });

      if (error.data) enqueueSnackbar(`${error.data.name} `, { variant: 'info' });
      if (errorMessage.redirect) {
        navigate(PATH_DASHBOARD.orders.open_orders);
      }
      throw new Error(error);
    }
  };

  const onSubmit = async (dataForm: any) => {
    try {
      const { items, ...rest } = dataForm;
      console.log('🚀 ~ CreateSimpleOrder ~ dataForm', dataForm);
      const valuesFormatted = dataForm.items.map((item: any) => {
        if (item.quantity + item.discountNumber < 1) {
          throw null;
        }

        const discountFlag = item.discountNumber > 0 && item.discount > 0;
        return {
          productId: Number(item.id),
          quantity: Number(item.quantity),
          description: item.description,
          discount: {
            discount: Number(discountFlag ? item.discount : 0),
            quantity_discount: Number(discountFlag ? item.discountNumber : 0),
          },
        };
      });
      console.log('🚀 ~ CreateSimpleOrder ~ valuesFormatted', {
        ...rest,
        ordersDetails: valuesFormatted,
      });
      await onCreateOrdersService({ ...rest, ordersDetails: valuesFormatted });
    } catch (error) {
      const errorMessage = new Error(error?.message);

      throw errorMessage;
    }
  };

  const {
    isLoading,
    fetchValues: onSubmitCreateOrder,
    // data: dataCreateOrder,
  } = useFetch({
    fetchFunction: createOrdersService,
    getData: true,
  });
  const generateRole = (role: number) => {
    if (role === Roles.ADMIN || role === Roles.SUPER_ADMIN || role === Roles.ATM) {
      return true;
    }
    return false;
  };
  const { user } = useAuthContext();
  const isAvailableVendor = generateRole(user?.role?.id ?? 1);
  const defaultValues = useMemo(
    () => defaultValuesProductForm({}),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAvailableVendor]
  );
  const methods = useForm<Partial<Order>>({
    mode: 'all',
    resolver: yupResolver(isAvailableVendor ? orderSchema : orderSchemaOptional),
    defaultValues,
  } as any);
  const {
    reset,
    handleSubmit,
    formState: { isSubmitting, isValid },
  } = methods;

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <div className="overflow-hidden">
        <div className="grid grid-cols-1 sm:grid-cols-[3fr_1fr] gap-4 relative">
        <div className="gap-3 items-end justify-end flex md:hidden">
              <Input
                placeholder="Escribe un producto"
                labelPlacement="outside"
                className="border-2 border-black rounded-lg w-full"
                startContent={
                  <SearchIcon
                    height={20}
                    width={20}
                    className="text-2xl text-default-400 pointer-events-none flex-shrink-0"
                  />
                }
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          <OrderSimpleButtons  searchTerm={searchTerm}/>
          <div className="space-y-4">
            {/* Aquí empieza el buscador */}
            <div className="gap-3 items-P justify-end hidden md:flex">
              <Input
                placeholder="Escribe un producto"
                labelPlacement="outside"
                className="border-2 border-black rounded-lg w-full"
                startContent={
                  <SearchIcon
                    height={20}
                    width={20}
                    className="text-2xl text-default-400 pointer-events-none flex-shrink-0"
                  />
                }
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Aquí empieza la factura */}
            <OrderFacturePreview
              isAvailableVendor={isAvailableVendor}
              isFoodCompany={isFoodCompany}
              isLoading={isLoading}
              isValid={isValid}
            />
          </div>
        </div>
      </div>
    </FormProvider>
  );
};
